export type AddTaskToResourceTranslation = {
  button: {
    addTask: string;
  };
};

export const addTaskToResourceTranslation: AddTaskToResourceTranslation = {
  button: {
    addTask: 'Dodaj zadanie',
  },
};
